import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuardService } from '../core/can-deactivate-guard.service';
import { QuestionarioMainComponent } from './questionario-main.component';
import { QuestionarioMenuComponent } from './questionario-menu.component';


const routes: Routes = [
  {
    path: 'menu-questionario',
    component: QuestionarioMenuComponent,
    canDeactivate: [CanDeactivateGuardService],
  },
  {
    path: 'questionario-eficiencia-energetica',
    component: QuestionarioMainComponent,
    canDeactivate: [CanDeactivateGuardService]
  },
  // retirar
  {
    path: 'questionario-eficiencia-energetica/id-interno/:id',
    component: QuestionarioMainComponent,
    canDeactivate: [CanDeactivateGuardService]        
  },
  {
    path: 'questionario-eficiencia-energetica/:cnpj/rascunho/:id',
    component: QuestionarioMainComponent,
    canDeactivate: [CanDeactivateGuardService]        
  },
  {
    path: 'questionario-eficiencia-energetica/:cnpj/token/:id',
    component: QuestionarioMainComponent,
    canDeactivate: [CanDeactivateGuardService]        
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuestionarioRoutingModule { }
